/*
  SALE COUNTDOWN.

  The remaining time is DERIVED FROM THE CLOCK rather than stored:

      remaining = cycle - (now mod cycle)

  Two consequences, both deliberate. It restarts on its own at the end of every cycle with nothing
  to persist and no reset code. And because the modulo is taken on UTC epoch milliseconds, every
  visitor sees the same number at the same instant — a per-visitor timer kept in localStorage hands
  two people different figures, which is precisely what makes a countdown look invented.

  One interval for the whole page however many banners are on it, and it stops itself when the tab
  is hidden — a timer nobody is looking at should not keep waking the CPU on a phone.
*/
(function () {
  var SELECTOR = '[data-sale-timer]';
  var HOUR_MS = 3600000;
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function render() {
    var nodes = document.querySelectorAll(SELECTOR);

    if (!nodes.length) {
      stop();
      return;
    }

    var now = Date.now();

    nodes.forEach(function (node) {
      var clock = node.querySelector('[data-sale-clock]');

      if (!clock) {
        return;
      }

      /* Guarded, because a merchant can clear the range setting and 0 would divide by zero. */
      var hours = parseFloat(node.getAttribute('data-cycle-hours')) || 24;
      var cycle = hours * HOUR_MS;
      var left = cycle - (now % cycle);

      var h = Math.floor(left / HOUR_MS);
      var m = Math.floor((left % HOUR_MS) / 60000);
      var s = Math.floor((left % 60000) / 1000);

      clock.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);

      /*
        A real machine-readable duration alongside the display string, so the figure is announced as
        a length of time rather than as a run of digits and colons.
      */
      clock.setAttribute('datetime', 'PT' + h + 'H' + m + 'M' + s + 'S');
    });
  }

  function start() {
    if (timer !== null) {
      return;
    }

    render();
    timer = window.setInterval(render, 1000);
  }

  function stop() {
    if (timer === null) {
      return;
    }

    window.clearInterval(timer);
    timer = null;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  /*
    Started on DOMContentLoaded when the script runs early, and immediately when it runs late — a
    deferred or cached script can land after the event has already fired, and waiting for an event
    that has passed leaves the clock reading --:--:-- forever.
  */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
